<script lang="ts">
    import MainLayout from "../../#common/layout/Layout.svelte"
    import {Link} from 'svelte-routing'
    import { navigate} from "src/components/cabinet/#common/helpers"
    import {doShow as showAlert} from "src/components/cabinet/#common/alert/store"
    import IconifyIcon from '@iconify/svelte'
    import createIcon from '@iconify/icons-fa-solid/plus-circle'
    import deleteIcon from '@iconify/icons-fa-solid/times'
    import {DataType} from 'src/services/api/common/http/HttpApi'
    import {api} from 'src/services/api/reallis'
    import {createPoll} from 'src/components/cabinet/#services/blogPolls'

    let saved = false
    $: question = ''
    $: answers = [{ isImage: true, answer: undefined }, { isImage: true, answer: undefined }]
    let date = new Date()
    date.setDate(date.getDate() + 7)
    let dd = String(date.getDate()).padStart(2, '0')
    let mm = String(date.getMonth() + 1).padStart(2, '0')
    let yyyy = date.getFullYear()
    $: endDate = yyyy+'-'+mm+'-'+dd

    async function onAnswerSelected(imageFile, index) {
        try {
            let response = await api.http.request({
                method: 'post',
                url: process.env.IMAGE_UPLOAD_URL+'blog',
                dataType: DataType.MultipartFormData,
                data: { image: imageFile }
            })
            answers[index].answer = response.data?.location
        } catch (err) {
            showAlert.set({
                status: 'error',
                text: 'An Error Occurred, Please Try Again Later'
            })
        }
    }

    async function create() {
        saved = true

        if (question !== '') {
            try {
                await createPoll.request({ data: { question, answers, endDate } })

                showAlert.set({
                    status: 'success',
                    text: 'Poll successfully created!'
                })

                setTimeout(function () {
                    navigate("/polls");
                }, 500)
            } catch (e) {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        }
    }

    function addAnswerHandler() {
        answers = [...answers, { isImage: true, answer: undefined }]
    }

    function deleteAnswerItem(index) {
        answers.splice(index, 1)
        answers = [...answers]
    }
</script>

<svelte:head>
    <title>Create poll</title>
</svelte:head>

<MainLayout title="Create poll">
    <svelte:fragment slot="content">
        <div class="card">
            <div class="card-body">
                <Link to="polls" class="btn btn-primary mb-3">Back</Link>
                <div class="row mb-3">
                    <div class="col-lg-8">
                        <div class="form-group mb-3">
                            <label>Question</label>
                            <input type="text" class="form-control" bind:value={question}
                                class:is-invalid={saved && question === ''}>
                            <label>Answers</label><br>
                            {#each answers as {isImage, answer}, i}
                                <div class="form-group mb-2">
                                    <div class="input-group">
                                        <span class="input-group-text">{i+1}</span>
                                        {#if !answers[i].answer}
                                            <div class="answer-thumb"></div>
                                        {:else}
                                            <a href={process.env.IMAGES_PATH+answers[i].answer} target="_blank" class="answer-thumb" rel="noreferrer">
                                                <img src={process.env.IMAGES_PATH+answers[i].answer} alt="">
                                            </a>
                                        {/if}
                                        <input type="file" class="form-control" accept=".jpg, .jpeg, .png, .gif" on:change={(e) => onAnswerSelected(e.target.files[0], i)}>
                                        <button class="input-group-text btn-danger" on:click={() => deleteAnswerItem(i)}>
                                            <IconifyIcon icon={deleteIcon}/>
                                        </button>
                                    </div>
                                </div>
                            {/each}
                            <button on:click={addAnswerHandler} class="btn btn-success mb-2">
                                <IconifyIcon icon={createIcon}/>
                            </button><br>
                            <label>End date</label>
                            <input type="date" class="form-control" bind:value={endDate} class:is-invalid={saved && endDate === ''}>
                        </div>
                    </div>
                </div>
                <button class="btn btn-success" on:click={create}>Create</button>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .input-group-text {
        height: 38px;
        min-width: 38px;
        font-size: 14px;
        color: #296bff;
    }

    .input-group-text.btn-danger {
        color: white;
    }

    .answer-thumb {
        height: 38px;
        width: 38px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #ced4da;
        background: #f5f6f7;
    }

    .answer-thumb img {
        height: 100%;
        width: 100%;
        object-fit: cover;
    }
</style>
